export const DOMICILIATION = [
    
]